import { NodeViewWrapper, type ReactNodeViewProps, useEditorState } from "@tiptap/react";
import { getHost } from "../host";

export const docHref = (code: string) => `/d/${encodeURIComponent(code)}`;

export function DocLinkView({ node, editor }: ReactNodeViewProps) {
  const editable = useEditorState({ editor, selector: ({ editor: e }) => e.isEditable });
  const code = String(node.attrs.code ?? "");
  const text = String(node.attrs.text ?? "");
  const inner = (
    <>
      <span className="kd-doclink__code">{code}</span>
      <span className="kd-doclink__text">{text}</span>
    </>
  );
  return (
    <NodeViewWrapper as="span" className="kd-doclink">
      {editable ? (
        inner
      ) : (
        <a
          href={docHref(code)}
          onClick={(e) => {
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
            e.preventDefault();
            getHost(editor).openDoc(code);
          }}
        >
          {inner}
        </a>
      )}
    </NodeViewWrapper>
  );
}
